import React from 'react'
import { convertToDate, getGradingNameFromGrade, isDefined, parseDateIsoFormat, selectNameByLanguage, titleize } from '../../utils/utils';
import I18n from 'i18n-js';
import LineChart from './LineChart';
import GameNameParser from './GameNameParser';

const GradingCertificatePopulationLinearChart = ({ grades, gradingsByScoreRounded, propskey = 'desktop' }) => {
  return (
    grades.map((grade, index) => {
      return (
        <div className='d-flex align-items-center justify-content-between py-0dot25rem' key={`${grade}_${propskey}`}>
          <div className={`text-semi-black label-charts${index % 2 === 1 ? '-half' : ''}-key-size`}>
            {grade}
          </div>
          <div className={`d-flex justify-content-start align-items-center px-3 w-100`}>
            <div className='evaluation-middle-chart-full-div' style={{ width: `${gradingsByScoreRounded[grade?.toString()]?.percentage || 0}%` }}></div>
            <div className='evaluation-middle-chart-thin-lines' style={{ width: `${100 - (gradingsByScoreRounded[grade?.toString()]?.percentage || 0)}%` }}></div>
          </div>
          <div className={`text-semi-black label-charts${index % 2 === 1 ? '-half' : ''}-key-size`}>
            {gradingsByScoreRounded[grade?.toString()]?.value || 0}
          </div>
        </div>
      )
    })
  )
}

const GradingCertificatePopulationCharts = ({ gradingChartData, gradedCardsCount, gradedProductsByEncasingCount, currentGrading, totalValuesFromScore, caseValuesFromScore, caseEvaluationPercentage, sleeveValuesFromScore, sleeveEvaluationPercentage, gradedBeforeCount, beforeDateGradedPercentage, gradedAfterCount, afterDateGradedPercentage, chartID = 'graded_population_chart_xl' }) => {
  return (
    <React.Fragment>
      <div className='bg-aig-gradient-light p-2 br-8px'>
        <div className='text-aig-gradient label-charts-label-size-title-legend pl-2 text--truncate'><b>{I18n.t('js.certificatePage.certificates')}</b></div>
        <div className='d-flex justify-content-around mt-3'>
          <LineChart
            type={'doughnut'}
            datasets={gradingChartData.datasets}
            labels={gradingChartData.labels}
            options={gradingChartData.options}
            maxHeight={'125px'}
            id={chartID}
          />
          <div className=''>
            <div className='py-2 label-charts-label-size-value-legend label-charts-issued-legend'>
              <b>{gradedCardsCount}</b><span className='label-charts-label-size-legend pl-2'>{I18n.t('js.certificatePage.issued').toUpperCase()}</span>
            </div>
            <div className='py-2 label-charts-case-legend'>
              <b className='label-charts-label-size-value-legend'>{gradedProductsByEncasingCount.case}</b><span className='label-charts-label-size-legend pl-2'>CASE</span>
            </div>
            <div className='py-2 label-charts-sleeve-legend'>
              <b className='label-charts-label-size-value-legend'>{gradedProductsByEncasingCount.sleeve}</b><span className='label-charts-label-size-legend pl-2'>SLEEVE</span>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-aig-gradient-light mt-4 p-2 br-8px'>
        <div className='text-aig-gradient label-charts-label-size-title-legend pl-2 text--truncate'><b>{`${isDefined(currentGrading.evaluations[1]) ? currentGrading.evaluations[1] : isDefined(getGradingNameFromGrade(currentGrading.grade_overall?.toString(), currentGrading.is_10_perfect)[1]) ? getGradingNameFromGrade(currentGrading.grade_overall?.toString(), currentGrading.is_10_perfect)[1] : 'Authentic'}`}</b></div>
        <div className='mt-2'>
          <div className=''>
            <div className='row p-2'>
              <div className='col-4 col-md-6 col-xxxl-5 text-right label-charts-issued-legend label-charts-label-size-value-legend'>
                <b>{totalValuesFromScore}</b><span className='label-charts-label-size-legend pl-2'>{I18n.t('js.certificatePage.issued').toUpperCase()}</span>
              </div>
              <div className='col-8 col-md-6 col-xxxl-7'>
                <div className='evaluation-chart-full-div-issued' style={{ width: '80%' }}></div>
              </div>
            </div>
            <div className='row p-2'>
              <div className='col-4 col-md-6 col-xxxl-5 text-right label-charts-case-legend label-charts-label-size-value-legend'>
                <b>{caseValuesFromScore || 0}</b><span className='label-charts-label-size-legend pl-2'>CASE</span>
              </div>
              <div className='col-8 col-md-6 col-xxxl-7'>
                <div className='evaluation-chart-full-div-case px-2' style={{ width: `${caseEvaluationPercentage || 0}%` }}></div>
              </div>
            </div>
            <div className='row p-2'>
              <div className='col-4 col-md-6 col-xxxl-5 text-right label-charts-sleeve-legend label-charts-label-size-value-legend'>
                <b>{sleeveValuesFromScore || 0}</b><span className='label-charts-label-size-legend pl-2'>SLEEVE</span>
              </div>
              <div className='col-8 col-md-6 col-xxxl-7'>
                <div className='evaluation-chart-full-div-sleeve px-2' style={{ width: `${sleeveEvaluationPercentage || 0}%` }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='bg-aig-gradient-light mt-4 p-2 br-8px'>
        <div className='text-aig-gradient label-charts-label-size-title-legend pl-2 text--truncate'><b>{I18n.t('js.certificatePage.certificateTimeline')}</b></div>
        <div className='mt-2'>
          <div className='d-flex justify-content-center align-items-baseline label-charts-issued-legend'>
            <span className='label-charts-label-size-legend'>{I18n.t('js.certificatePage.issueDate').toUpperCase()}</span>
            <b className='pl-2 label-charts-label-size-value-legend'>{currentGrading.parsed_created_at}</b>
          </div>
          <div className='mt-2'>
            <div className='row px-4'>
              <div className='col-6 d-flex align-items-center flex-column'>
                <div className='d-flex evaluation-chart-height'>
                  <div className='evaluation-chart-full-div-sleeve align-self-end timeline-chart-width' style={{ height: `${beforeDateGradedPercentage}px` }}></div>
                </div>
                <div className='label-charts-sleeve-legend label-charts-label-size-value-legend pt-2'>
                  <b>{gradedBeforeCount}</b>
                  <span className='label-charts-label-size-legend pl-2'>{I18n.t('js.certificatePage.issueDateBefore').toUpperCase()}</span>
                </div>
              </div>
              <div className='col-6 d-flex align-items-center flex-column'>
                <div className='d-flex evaluation-chart-height'>
                  <div className='evaluation-chart-full-div-case align-self-end timeline-chart-width' style={{ height: `${afterDateGradedPercentage}px` }}></div>
                </div>
                <div className='label-charts-case-legend label-charts-label-size-value-legend pt-2'>
                  <b>{gradedAfterCount}</b>
                  <span className='label-charts-label-size-legend pl-2'>{I18n.t('js.certificatePage.issueDateAfter').toUpperCase()}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

const GradingCertificatePopulation = ({ blueprintImage, currentGrading, gradedCardsCount, gradingsByScore, gradingsByEncasing, gradedProductsByEncasingCount, gradedBeforeCount, gradedAfterCount }) => {

  function transformHash(inputHash) {
    const outputHash = {};
    let maxValue = 0;

    Object.keys(inputHash).forEach((key) => {
      if (key === 'authentic') {
        outputHash['A'] = (outputHash['A'] || 0) + inputHash[key];
        maxValue = Math.max(maxValue, outputHash['A']);
      } else if (key === '10.5') {
        outputHash['10P'] = inputHash[key];
        maxValue = Math.max(maxValue, outputHash['10P']);
      } else if (key.includes('.0')) {
        const baseKey = key.split('.')[0];
        outputHash[baseKey] = (outputHash[baseKey] || 0) + inputHash[key];
        maxValue = Math.max(maxValue, outputHash[baseKey]);
      } else {
        outputHash[key] = inputHash[key];
        maxValue = Math.max(maxValue, outputHash[key]);
      }
    });

    const transformedHash = {};
    Object.keys(outputHash).forEach((key) => {
      transformedHash[key] = {
        value: outputHash[key],
        percentage: ((outputHash[key] / maxValue) * 100).toFixed(2)
      };
    });

    return { transformHash: transformedHash, maxValue: maxValue };
  }

  const grades = ['10P', '10', '9.5', '9', '8.5', '8', '7.5', '7', '6.5', '6', '5.5', '5', '4.5', '4', '3.5', '3', '2.5', '2', '1.5', '1', 'A'];

  const frontImage = blueprintImage?.xx_large_image_url
  const backImage = blueprintImage?.xx_large_back_image_url

  const resultTransformedHash = transformHash(gradingsByScore);
  const gradingsByScoreRounded = resultTransformedHash.transformHash;

  const gradingChartLabels = ['sleeve', 'case'];

  const caseValues = gradingsByEncasing['case'];
  const sleeveValues = gradingsByEncasing['sleeve'];

  const caseValuesFromScore = currentGrading.is_authentic ? caseValues['authentic'] : caseValues[(currentGrading.is_10_perfect ? '10.5' : currentGrading.grade_overall?.toFixed(1))]
  const sleeveValuesFromScore = currentGrading.is_authentic ? sleeveValues['authentic'] : sleeveValues[(currentGrading.is_10_perfect ? '10.5' : currentGrading.grade_overall?.toFixed(1))]

  const totalValuesFromScore = (caseValuesFromScore || 0) + (sleeveValuesFromScore || 0);

  const currentDate = parseDateIsoFormat(new Date(currentGrading.created_at), '%Y-%m-%d');

  const gradingChartData = {
    labels: gradingChartLabels,
    datasets: [{ data: [gradedProductsByEncasingCount.sleeve, gradedProductsByEncasingCount.case], backgroundColor: ['rgb(0, 202, 219)', 'rgb(160, 106, 247)'] }],
    options: {
      responsive: true,
      maintainAspectRatio: true,
      plugins: {
        tooltip: {
          enabled: true
        },
        legend: {
          display: false
        },
        datalabels: {
          display: false
        }
      },
      cutout: '70%'
    }
  }

  const caseEvaluationPercentage = (caseValuesFromScore / totalValuesFromScore) * 80.00
  const sleeveEvaluationPercentage = (sleeveValuesFromScore / totalValuesFromScore) * 80.00

  const beforeDateGradedPercentage = (gradedBeforeCount / gradedCardsCount) * (window.innerWidth > 2200 ? 120.00 : 80.00)
  const afterDateGradedPercentage = (gradedAfterCount / gradedCardsCount) * (window.innerWidth > 2200 ? 120.00 : 80.00)

  return (
    <div>
      <div className='d-flex row mx-0 mt-4 pt-1 align-items-end'>
        <div className='col-7 col-sm-8 col-md-9 col-lg-9 col-xl-9 col-xxl-9-dot-5 col-xxxl-10 pl-md-3 pl-lg-5 pr-0'>
          <div className="border-bottom-light-gray">
            <span className="certificate-page-title-label">{I18n.t('js.certificatePage.populationReport').toUpperCase()}</span>
          </div>
        </div>
        <div className='d-flex justify-content-start col-5 col-sm-4 col-md-3 col-lg-3 col-xl-3 col-xxl-2-dot-5 col-xxxl-2 pl-0'>
          <img alt="" className='logo-aig-certificate-width' src={'/images/logo-AIGRADING-white.png'} />
        </div>
      </div>

      <div className='row mx-0 min-h-vh-88'>
        <div className='d-none d-lg-flex col-lg-1 col-xl-1 col-xxl-0-dot-5 col-xxxl-1'></div>
        <div className='d-none d-md-block col-12 col-md-6 col-lg-8 col-xl-8 col-xxl-8 col-xxxl-8 p-0 mt-4'>
          <div className='row d-none d-xl-flex mt-4 m-0'>
            <div className={'col-6 col-md-4 col-xl-3 certificate-border-bottom certificate-border-right'}>
              <div className="my-1">
                <span className="certificate-label-title">{I18n.t('js.certificatePage.itemName').toUpperCase()}</span>
              </div>
              <div className="mb-1 text--truncate">
                <span className="certificate-label-value-no-padding">
                  {selectNameByLanguage(currentGrading.label_language, blueprintImage.meta_name, blueprintImage.en_name)}
                </span>
              </div>
            </div>
            <div className={'col-6 col-md-4 col-xl-3 certificate-border-md-right certificate-border-bottom'}>
              <div className="my-1">
                <span className="certificate-label-title">{I18n.t('js.cardInfoPage.game').toUpperCase()}&nbsp;</span>
              </div>
              <div className="mb-1">
                <span className="certificate-label-value-no-padding"><GameNameParser game_name={blueprintImage.game.name} /></span>
              </div>
            </div>
            <div className={'col-6 col-md-4 col-xl-3 certificate-border-bottom certificate-border-right'}>
              <div className="my-1">
                <span className="certificate-label-title">{I18n.t('js.cardInfoPage.era').toUpperCase()}&nbsp;</span>
              </div>
              <div className="mb-1">
                <span className="certificate-label-value-no-padding">
                  {selectNameByLanguage(currentGrading.label_language, blueprintImage.era_name, blueprintImage.en_era_name)}
                </span>
              </div>

            </div>
            <div className={'col-6 col-md-4 col-xl-3 certificate-border-md-right border-right-xl-none certificate-border-bottom'}>
              <div className="my-1">
                <span className="certificate-label-title">{I18n.t('js.cardInfoPage.expansion').toUpperCase()}</span>
              </div>
              <div className="mb-1">
                <div className="text--truncate">
                  <span className="certificate-label-value-no-padding">
                    {selectNameByLanguage(currentGrading.label_language, blueprintImage.expansion_name, blueprintImage.en_expansion_name)}
                  </span>
                </div>
              </div>
            </div>

            <div className={'col-6 col-md-4 col-xl-3 certificate-border-bottom border-bottom-xl-none certificate-border-right'}>
              <div className="my-1">
                <span className="certificate-label-title"> {I18n.t('js.certificatePage.itemNumber').toUpperCase()}&nbsp;</span>
              </div>
              <div className="mb-1">
                <span className="certificate-label-value-no-padding">{blueprintImage.collector_number || '-'}</span>
              </div>
            </div>
            <div className={'col-6 col-md-4 col-xl-3 certificate-border-bottom border-bottom-md-none certificate-border-md-right'}>
              <div className="my-1">
                <span className="certificate-label-title">{I18n.t('js.cardInfoPage.version').toUpperCase()}&nbsp;</span>
              </div>
              <div className="mb-1">
                <span className="certificate-label-value-no-padding">{titleize(blueprintImage.version) || '-'}</span>
              </div>
            </div>
            <div className={'col-6 col-md-4 col-xl-3 certificate-border-right'}>
              <div className="my-1">
                <span className="certificate-label-title">{I18n.t('js.cardInfoPage.rarity').toUpperCase()}&nbsp;</span>
              </div>
              <div className="mb-1">
                <div className="text--truncate">
                  <span className="certificate-label-value-no-padding">{titleize(blueprintImage.rarity) || '-'}</span>
                </div>
              </div>
            </div>
            <div className={'col-6 col-md-4 col-xl-3'}>
              <div className="my-1">
                <span className="certificate-label-title"> {I18n.t('js.cardInfoPage.release').toUpperCase()}&nbsp;</span>
              </div>
              <div className="mb-1">
                <span className="certificate-label-value-no-padding">{parseDateIsoFormat(convertToDate(blueprintImage.released_at), '%d/%m/%Y')}</span>
              </div>
            </div>

          </div>
          <div className='row justify-content-center mt-4 py-2 align-items-end min-h-vh-xl-70'>
            <div className='col-8 col-lg-5 col-xl-4 col-xxxl-3 ml-n5'>
              <GradingCertificatePopulationCharts
                gradingChartData={gradingChartData}
                gradedCardsCount={gradedCardsCount}
                gradedProductsByEncasingCount={gradedProductsByEncasingCount}
                currentGrading={currentGrading}
                totalValuesFromScore={totalValuesFromScore}
                caseValuesFromScore={caseValuesFromScore}
                caseEvaluationPercentage={caseEvaluationPercentage}
                sleeveValuesFromScore={sleeveValuesFromScore}
                sleeveEvaluationPercentage={sleeveEvaluationPercentage}
                gradedBeforeCount={gradedBeforeCount}
                beforeDateGradedPercentage={beforeDateGradedPercentage}
                gradedAfterCount={gradedAfterCount}
                afterDateGradedPercentage={afterDateGradedPercentage}
                chartID={'graded_population_chart_md'}
              />
            </div>
            <div className='col-8 col-lg-7 col-xl-8 col-xxxl-9 d-none d-lg-flex'>
              <div className='align-self-baseline d-none d-xxl-flex'>
                <div className='pt-4'>
                  <div className='extended-serial-number-div'>
                    <span className='evaluation-middle-chart-near-label'>{I18n.t('js.certificatePage.grades').toUpperCase()}</span>
                  </div>
                </div>
              </div>
              <div className='px-0 w-100'>
                <GradingCertificatePopulationLinearChart grades={grades} gradingsByScoreRounded={gradingsByScoreRounded} propskey={'desktop'} />
              </div>
              <div className='align-self-end d-none d-xxxl-flex'>
                <div className='pb-3_6rem'>
                  <div className='extended-serial-number-div'>
                    <span className='evaluation-middle-chart-near-label'>{I18n.t('js.certificatePage.population').toUpperCase()}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='col-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3-dot-5 col-xxxl-3 pl-0 mt-md-5-perc'>
          <div className={`d-flex justify-content-center ${backImage ? 'justify-content-xxl-start' : ''} my-5 my-xl-0`}>
            <div className="content">
              <div className="certificate-image-container px-2">
                <img alt="" src={frontImage || '/images/placeholder/xx_large_placeholder.png'} width={350} className='br-16px' />
                {backImage && (
                  <img alt="" src={backImage} className='d-none d-xxl-flex br-16px' />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className='d-xl-none col-12'>
          <div className='row mx-sm-2 px-sm-2'>
            <div className='col-6 certificate-border-bottom certificate-border-right'>
              <div className="my-1">
                <span className="certificate-label-title">{I18n.t('js.certificatePage.itemName').toUpperCase()}</span>
              </div>
              <div className="mb-1 text--truncate">
                <span className="certificate-label-value-no-padding">
                  {selectNameByLanguage(currentGrading.label_language, blueprintImage.meta_name, blueprintImage.en_name)}
                </span>
              </div>
            </div>
            <div className='col-6 certificate-border-bottom'>
              <div className="my-1">
                <span className="certificate-label-title">{I18n.t('js.cardInfoPage.game').toUpperCase()}&nbsp;</span>
              </div>
              <div className="mb-1">
                <span className="certificate-label-value-no-padding"><GameNameParser game_name={blueprintImage.game.name} /></span>
              </div>
            </div>
            <div className='col-6 certificate-border-bottom certificate-border-right'>
              <div className="my-1">
                <span className="certificate-label-title">{I18n.t('js.cardInfoPage.era').toUpperCase()}&nbsp;</span>
              </div>
              <div className="mb-1">
                <span className="certificate-label-value-no-padding">
                  {selectNameByLanguage(currentGrading.label_language, blueprintImage.era_name, blueprintImage.en_era_name)}
                </span>
              </div>
            </div>
            <div className='col-6 certificate-border-bottom'>
              <div className="my-1">
                <span className="certificate-label-title">{I18n.t('js.cardInfoPage.expansion').toUpperCase()}</span>
              </div>
              <div className="mb-1">
                <div className="text--truncate">
                  <span className="certificate-label-value-no-padding">
                    {selectNameByLanguage(currentGrading.label_language, blueprintImage.expansion_name, blueprintImage.en_expansion_name)}
                  </span>
                </div>
              </div>
            </div>

            <div className='col-6 certificate-border-bottom certificate-border-right'>
              <div className="my-1">
                <span className="certificate-label-title"> {I18n.t('js.certificatePage.itemNumber').toUpperCase()}&nbsp;</span>
              </div>
              <div className="mb-1">
                <span className="certificate-label-value-no-padding">{blueprintImage.collector_number || '-'}</span>
              </div>
            </div>
            <div className='col-6 certificate-border-bottom'>
              <div className="my-1">
                <span className="certificate-label-title">{I18n.t('js.cardInfoPage.version').toUpperCase()}&nbsp;</span>
              </div>
              <div className="mb-1">
                <span className="certificate-label-value-no-padding">{titleize(blueprintImage.version) || '-'}</span>
              </div>
            </div>
            <div className='col-6 certificate-border-right'>
              <div className="my-1">
                <span className="certificate-label-title">{I18n.t('js.cardInfoPage.rarity').toUpperCase()}&nbsp;</span>
              </div>
              <div className="mb-1">
                <div className="text--truncate">
                  <span className="certificate-label-value-no-padding">{titleize(blueprintImage.rarity) || '-'}</span>
                </div>
              </div>
            </div>
            <div className='col-6'>
              <div className="my-1">
                <span className="certificate-label-title"> {I18n.t('js.cardInfoPage.release').toUpperCase()}&nbsp;</span>
              </div>
              <div className="mb-1">
                <span className="certificate-label-value-no-padding">{parseDateIsoFormat(convertToDate(blueprintImage.released_at), '%d/%m/%Y')}</span>
              </div>
            </div>
          </div>
        </div>
        <div className='d-lg-none col-12 mt-4 px-3 px-md-5'>
          <div className='center-block col-12 col-sm-10 d-md-none'>
            <GradingCertificatePopulationCharts
              gradingChartData={gradingChartData}
              gradedCardsCount={gradedCardsCount}
              gradedProductsByEncasingCount={gradedProductsByEncasingCount}
              currentGrading={currentGrading}
              totalValuesFromScore={totalValuesFromScore}
              caseValuesFromScore={caseValuesFromScore}
              caseEvaluationPercentage={caseEvaluationPercentage}
              sleeveValuesFromScore={sleeveValuesFromScore}
              sleeveEvaluationPercentage={sleeveEvaluationPercentage}
              currentDate={currentDate}
              gradedBeforeCount={gradedBeforeCount}
              beforeDateGradedPercentage={beforeDateGradedPercentage}
              gradedAfterCount={gradedAfterCount}
              afterDateGradedPercentage={afterDateGradedPercentage}
              chartID={'graded_population_chart_sm'}
            />
          </div>
          <div className='px-2 py-4 w-100'>
            <GradingCertificatePopulationLinearChart grades={grades} gradingsByScoreRounded={gradingsByScoreRounded} propskey={'mobile'} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default GradingCertificatePopulation;
